module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 /* allowHtmlVariables hasActiveConsuls */ 
__p+='\n\n<div class="cta cta-becomeConsul">\n    <div class="cta__image">\n        <i class="icon icon-consul-darkBlue icon-xxxxlargeBelowTablet"></i>\n    </div>\n    <div class="cta__content">\n        <h3>\n            Want to become a Consul?\n        </h3>\n        <span>\n        Share your passion by hosting regular activities!\n        ';
 if (isLoggedIn) { 
__p+='\n            <a href="'+
((__t=(link.learnMore ))==null?'':_.escape(__t))+
'">Learn more</a>\n        ';
 } 
__p+='\n        </span>\n    </div>\n    <div class="cta__action">\n        ';
 if (isLoggedIn) { 
__p+='\n            <a class="js-modal-trigger btn" href="javascript:void(0);" data-href="'+
((__t=(link.button ))==null?'':_.escape(__t))+
'">Apply as Consul</a>\n        ';
 } else { 
__p+='\n            <a class="btn" href="'+
((__t=(link.learnMore ))==null?'':_.escape(__t))+
'">Learn more</a>\n        ';
 } 
__p+='\n    </div>\n</div>\n';
}
return __p;
};
